export default function(params) {
  this.defaults = {}
  this.removeHeroIimage = ko.observable()
  this.removeOutletLogo = ko.observable()
  this.removeFeaturedOnLogo = ko.observable()
  this.editing = ko.observable(false)
  this.shouldDelete = ko.observable(false)

  this.config = Object.assign({}, this.defaults, params)

  this.init = () => {
    const json = JSON.parse(params)

    // Additional params
    json.publish_date_string = json.publish_date
    json.schedule_date_string = json.schedule_date
    json.remote_hero_image_url = json.hero_image.url
    json.remote_outlet_logo_url = json.outlet_logo.url
    json.remote_featured_on_logo_url = json.featured_on_logo.url

    this.mapped = ko.mapping.fromJS(json)

    this.editing(this.mapped.id() ? true : false)

    this.initDropZones()
    this.initColorPickers()
  }

  this.initDropZones = () => {
    const $dropzones = $('.js-article-dz')

    $dropzones.each((_idx, dropZone) => {
      const $dropZone = $(dropZone)
      const templateConfig = $dropZone.data().dzConfig

      templateConfig.dropFilesTitle = I18n.t('drop_file_editor.drop_file_title')
      templateConfig.dragAndDrop = I18n.t('drop_file_editor.drag_and_drop')
      templateConfig.browseFiles = I18n.t('drop_file_editor.browse_files')
      templateConfig.dimentionLabel = I18n.t('drop_file_editor.dimensions_label')
      templateConfig.maxFilesizeLabel = I18n.t('drop_file_editor.max_file_size')
      templateConfig.fileTypesLabel = I18n.t('drop_file_editor.file_types')
      templateConfig.optionalLable = I18n.t('drop_file_editor.optional')

      const uploadUrl = Kadenze.Routes.temp_image_upload_path(),
        observableRef = $dropZone.data('dz-name'),
        message = JST['templates/dropzone-generic'](templateConfig),
        options = {
          dzName: templateConfig.title,
          previewable: true,
          dzPreview: JST['templates/dropzone-generic-img-preview']({
            previewable: true,
            nameLabel: I18n.t('file_preview.name'),
            sizeLabel: I18n.t('file_preview.size'),
            previewLabel: I18n.t('file_preview.preview'),
            removeLabel: I18n.t('file_preview.remove_file'),
            fileUploadProgressLabel: I18n.t('file_preview.file_upload_progress')
          }),
          maxFilesize: templateConfig.maxFilesize,
          acceptedFiles: templateConfig.acceptedFiles
        }

      const curFileObj = {
        path: this.mapped[observableRef].url()
      }

      const callbacks = {
        success: (file, response) => {
          this.mapped['remote_' + observableRef + '_url'](response.path)
        },

        removedfile: () => {}
      }

      $dropZone.data('dz', new Kadenze.ImageDropZone(
        $dropZone,
        message,
        uploadUrl,
        callbacks,
        curFileObj,
        options
      ))
    })
  }

  this.initColorPickers = () => {
    const $picker = $('.input--colorpicker')

    $picker.colorpicker({ format: 'hex' })

    $picker.on('changeColor.colorpicker', event => {
      this.mapped.logo_background_color(event.color.toHex())
    })
  }

  this.delete = vm => {
    Kadenze.UIUtil.confirmAction(I18n.t('notice.delete_article'), () => {
      this.shouldDelete(true)
      this.save(vm)
    })
  }

  this.saveDraft = vm => {
    const button = Ladda.create($('#article-draft')[0])
    vm.status = 'draft'
    this.save(vm, button)
  }

  this.publish = vm => {
    const button = Ladda.create($('#article-publish')[0])
    this.save(vm, button)
  }

  this.update = vm => {
    const button = Ladda.create($('#article-update')[0])
    this.save(vm, button)
  }

  this.save = (data, loaderButton) => {
    const json = ko.mapping.toJS(data)

    let requestURL = Kadenze.Routes.admin_articles_path()
    let requestType = 'POST'

    if (loaderButton)
      loaderButton.start()

    if (this.shouldDelete()) {
      requestURL = Kadenze.Routes.admin_article_path(json.id)
      requestType = 'DELETE'
    } else if(this.editing()) {
      requestURL = Kadenze.Routes.admin_article_path(json.id)
      requestType = 'PUT'
    }

    const request = new Kadenze.AjaxRequest({
      type: requestType,
      url: requestURL,
      data: { article: json  }
    })

    request.done(response => {
      new Kadenze.Notice.success({ message: response.message })

      if(loaderButton)
        loaderButton.stop()

      window.location = Kadenze.Routes.admin_articles_path()
    })

    request.fail(response => {
      loaderButton.stop()

      const message = response.responseJSON ?
        response.responseJSON.message :
        I18n.t('notice.unexpected_error')

      new Kadenze.Notice.error({ message: message })
    })
  }

  this.init()
}
